
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarSettingsProposal as ObiRadarSettingsProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-settings-proposal.js';
 
 
 

 
 export const ObiRadarSettingsProposal = createComponent({
   react: React,
   tagName: 'obi-radar-settings-proposal',
   elementClass: ObiRadarSettingsProposalElement,
   events: {
     
   }
  });
 
 